'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Discussion;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _renderIf = require('render-if');

var _renderIf2 = _interopRequireDefault(_renderIf);

var _discussions = require('../api/discussions');

var _MessageFormContainer = require('./MessageFormContainer');

var _MessageFormContainer2 = _interopRequireDefault(_MessageFormContainer);

var _MessageListContainer = require('./MessageListContainer');

var _MessageListContainer2 = _interopRequireDefault(_MessageListContainer);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
function Discussion(_ref, _ref2) {
	var id = _ref.id;
	var subject = _ref.subject;
	var user = _ref.user;
	var status = _ref.status;
	var participants = _ref.participants;
	var CustomComponent = _ref2.CustomComponent;

	var disabled = status !== _discussions.Status.OPEN;

	return _react2.default.createElement(
		'section',
		{ className: 'vtChat-Discussion' },
		_react2.default.createElement(
			'header',
			{ className: 'vtChat-Discussion-header' },
			_react2.default.createElement(
				'h2',
				{ className: 'vtChat-Discussion-title' },
				_react2.default.createElement(_reactIntl.FormattedMessage, {
					id: 'vtChat.Discussion.title',
					values: { subject: subject }
				})
			)
		),
		(0, _renderIf2.default)(CustomComponent)(function () {
			return (0, _react.cloneElement)(CustomComponent, { student: (0, _lodash.first)(participants) });
		}),
		(0, _renderIf2.default)(disabled)(function () {
			return _react2.default.createElement(
				'p',
				{ className: 'vtChat-Discussion-statusMessage' },
				_react2.default.createElement(_reactIntl.FormattedMessage, {
					id: 'vtChat.Discussion.statusMessage',
					values: { status: status }
				})
			);
		}),
		_react2.default.createElement(
			'div',
			{ className: 'vtChat-Discussion-body' },
			_react2.default.createElement(_MessageListContainer2.default, { discussionId: id, disabled: disabled })
		),
		_react2.default.createElement(_MessageFormContainer2.default, {
			discussionId: id,
			author: user,
			disabled: disabled
		})
	);
}

Discussion.propTypes = {
	id: _react.PropTypes.string.isRequired,
	subject: _react.PropTypes.string.isRequired,
	user: _react.PropTypes.object.isRequired,
	status: _discussions.StatusPropType.isRequired
};

Discussion.contextTypes = {
	CustomComponent: _react.PropTypes.element
};